import { Button } from '@/features/shared';
import { MuiBox, MuiInputBase } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { Tooltip, useMediaQuery } from '@material-ui/core';
import { useTheme, withStyles } from '@material-ui/core/styles';
import { Search as SearchIcon } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { SearchInputProps, SearchInputVariantEnum } from './SearchInput.interface';
import useSearchInputStyles from './SearchInput.styles';

const TooltipWhite = withStyles(() => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    fontSize: 11,
  },
}))(Tooltip);

const SearchInput = ({
  onChange,
  searchHint,
  onKeyPress,
  value,
  searchTip,
  theme = Theme.light,
  variant = SearchInputVariantEnum.withLabel,
  searchLabel,
  onSearchButtonClick = () => {},
}: SearchInputProps) => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const classes = useSearchInputStyles();

  const RenderSearchIcon = () => (
    <TooltipWhite title={searchTip || ''} enterDelay={1000}>
      <span>
        <MuiBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          className={classes.searchIcon}
        >
          <SearchIcon className={classes.icon} />
        </MuiBox>
      </span>
    </TooltipWhite>
  );

  return (
    <MuiBox
      display="flex"
      order={isMobile ? 2 : 3}
      alignItems="center"
      className={clsx(classes.search, `${theme}-theme`)}
    >
      {variant === SearchInputVariantEnum.withLabel && <RenderSearchIcon />}
      <MuiInputBase
        placeholder={searchHint}
        classes={{
          root: clsx(classes.inputRoot, `${theme}-theme`),
          input: clsx(classes.inputInput, `${theme}-theme`, `${variant}-variant`),
        }}
        value={value}
        inputProps={{ 'aria-label': 'search' }}
        onChange={onChange}
        onKeyPress={onKeyPress}
        data-testid="filtered-list--search"
      />
      {variant === SearchInputVariantEnum.withLabel && (
        <Button variant="text" className={classes.searchActionLabel} onClick={onSearchButtonClick}>
          {searchLabel}
        </Button>
      )}
      {variant === SearchInputVariantEnum.onlyIcon && <RenderSearchIcon />}
    </MuiBox>
  );
};

export default SearchInput;
